import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { API } from "../../helper/Api";
import { FaCheckCircle, FaRegCheckCircle } from "react-icons/fa";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate } from "react-router-dom";


const ListStores = () => {
  const navigate = useNavigate();
  const goToEditStore = (corporatestorenbr) => {
    navigate("/editstores", {
      state: { corporatestorenbr }, // data passed via POST-like behavior
    });
  };
    const [storeData, setStoreData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    
    
  
    useEffect(() => {

      const successMessage = sessionStorage.getItem("successMessage");
  
      if (successMessage) {
        toast.success(successMessage, {
          position: "top-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          className: "login-toast",
        });
        sessionStorage.removeItem("successMessage");
      }

        const fetchStores = async () => {
          try {
            const response = await API.storeSetting("list");
            console.log("Store response:", response);
            // exit;
            setStoreData(response.data);  
            setFilteredData(response.data);
          } catch (error) {
            console.error("Error fetching store data:", error);
          }
        };
      
        fetchStores();
      }, []);

      const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
      
        const filtered = storeData.filter((store) =>
          Object.values(store).some(
            (field) => field && field.toString().toLowerCase().includes(value)
          )
        );
      
        setFilteredData(filtered);
      };
      
  
   
  
    const columns = [
      { name: "Parent No", selector: (row) => row.parentno, sortable: true, width: "130px"},
      { name: "Corpstorenbr", selector: (row) => row.corporatestorenbr, sortable: true, width: "150px"},
      // { name: "Access Token", selector: (row) => row.access_token },
      // { name: "API Key", selector: (row) => row.api_key },
      // { name: "API Secret Key", selector: (row) => row.api_secretkey },
      { name: "Store Name", selector: (row) => row.storename, sortable: true, width: "150px", cell: (row) => <div className="table-cell-wrap">{row.storename}</div> },
      { name: "Store Status", selector: (row) => row.storestatus, sortable: true, width: "150px" },
      // {
      //   name: "Location",
      //   selector: (row) => {
      //     const city = row.storecity || "";
      //     const state = row.storestate || "";
      //     return city && state ? `${city}, ${state}` : city || state || "";
      //   },
      //   sortable: true, width: "120px"
      // },
      {
        name: "Web Url",
        selector: (row) => row.shopify_websiteurl,
        cell: (row) => (
          <a href={row.shopify_websiteurl} target="_blank" rel="noopener noreferrer">
            {"Web Url"}
          </a>
        ), width: "140px"
      },
      {
        name: "Admin Url",
        selector: (row) => row.shopify_adminurl,
        cell: (row) => (
          <a href={row.shopify_adminurl} target="_blank" rel="noopener noreferrer">
            {"Admin Url"}
          </a>
        ), width: "140px"
      },
      { name: "UTC", selector: (row) => row.utc, width: "80px" },
      { name: "UTC Dates", selector: (row) => row.utc_dates, width: "120px" },
      // {
      //   name: "Loc.Id",
      //   selector: (row) => row.location_id,
      //   width: "110px",
      //   cell: (row) => (
      //     <div className="table-cell-wrap" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
      //       {(row.location_id || "").split(",").map((id, index, arr) => (
      //         <div key={index}>
      //           {id.trim()}{index !== arr.length - 1 && ','}
      //         </div>
      //       ))}
      //     </div>
      //   ),
      // },
      // {
      //   name: "Loc.Name",
      //   selector: (row) => row.location_name,
      //   width: "110px",
      //   cell: (row) => (
      //     <div className="table-cell-wrap" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
      //       {(row.location_name || "").split(",").map((name, index, arr) => (
      //         <div key={index}>
      //           {name.trim()}{index !== arr.length - 1 && ','}
      //         </div>
      //       ))}
      //     </div>
      //   ),
      // },
      
      
      
      
      // {
      //   name: "Extract Name",
      //   cell: (row) => (
      //     <div style={{
      //       whiteSpace: "pre-wrap",
      //       wordBreak: "break-word",
      //       textAlign: "center",
      //       margin: "0 auto"
      //     }}>
      //       {row.extract_name || "N/A"}
      //     </div>
      //   ),
      //   center: true,
      // },      
      // {
      //   name: "Enable Extract",
      //   cell: (row) => (
      //     <div style={{
      //       whiteSpace: "pre-wrap",
      //       wordBreak: "break-word",
      //       textAlign: "center",
      //       margin: "0 auto"
      //     }}>
      //       {row.enable_extract
      //         ? row.enable_extract
      //             .split(",")
      //             .map((val) => val.trim().charAt(0).toLowerCase() + val.trim().slice(1))
      //             .join(",\n")
      //         : "N/A"}
      //     </div>
      //   ),
      //   center: true,
      // },
      // {
      //   name: "Extracts",
      //   cell: (row) => {
      //     const names = row.extract_name ? row.extract_name.split("\n") : [];
      //     const statuses = row.enable_extract ? row.enable_extract.split("\n") : [];
      
      //     const display = names.map((name, index) => {
      //       //const cleanName = name.trim().charAt(0).toLowerCase() + name.trim().slice(1);
      //       const status = statuses[index] === "1" ? "yes" : "no";
      //       return `${status}`;
      //     });
      
      //     return (
      //       <div style={{
      //         whiteSpace: "pre-wrap",
      //         wordBreak: "break-word",
      //         textAlign: "center",
      //         margin: "0 auto"
      //       }}>
      //         {display.length ? display.join("\n") : "N/A"}
      //       </div>
      //     );
      //   },
      //   center: true,
      // }
      {
        name: "Extracts",
        cell: (row) => {
          const names = row.extract_name ? row.extract_name.split("\n") : [];
          const statuses = row.enable_extract ? row.enable_extract.split("\n") : [];
      
          const allChecked = statuses.length > 0 && statuses.every((s) => s === "1");
      
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              {allChecked ? (
                <FaCheckCircle style={{ color: "green", fontSize: "1.5rem" }} />
              ) : (
                <FaRegCheckCircle
                  style={{ color: "grey", opacity: 0.5, fontSize: "1.5rem" }}
                />
              )}
            </div>
          );
        },
        center: true, width: "90px"
      },
      {
        name: "Actions",
        cell: (row) => (
          <div>
            <button
              // to={`/editstores/${row.corporatestorenbr}`}
              onClick={() => goToEditStore(row.corporatestorenbr)}
              style={{
                backgroundColor: "#c2fbd7",
                borderRadius: "100px",
                boxShadow:
                  "rgba(44, 187, 99, 0.2) 0 -25px 18px -14px inset, rgba(44, 187, 99, 0.15) 0 1px 2px, rgba(44, 187, 99, 0.15) 0 2px 4px, rgba(44, 187, 99, 0.15) 0 4px 8px, rgba(44, 187, 99, 0.15) 0 8px 16px, rgba(44, 187, 99, 0.15) 0 16px 32px",
                color: "green",
                cursor: "pointer",
                display: "inline-block",
                fontFamily: "CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif",
                padding: "7px 20px",
                textAlign: "center",
                textDecoration: "none",
                transition: "all 250ms",
                border: "0",
                fontSize: "14px",
                userSelect: "none",
              }}
              onMouseEnter={(e) => {
                e.target.style.boxShadow =
                  "rgba(44,187,99,.35) 0 -25px 18px -14px inset, rgba(44,187,99,.25) 0 1px 2px, rgba(44,187,99,.25) 0 2px 4px, rgba(44,187,99,.25) 0 4px 8px, rgba(44,187,99,.25) 0 8px 16px, rgba(44,187,99,.25) 0 16px 32px";
                e.target.style.transform = "scale(1.05) rotate(-1deg)";
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow =
                  "rgba(44, 187, 99, 0.2) 0 -25px 18px -14px inset, rgba(44, 187, 99, 0.15) 0 1px 2px, rgba(44, 187, 99, 0.15) 0 2px 4px, rgba(44, 187, 99, 0.15) 0 4px 8px, rgba(44, 187, 99, 0.15) 0 8px 16px, rgba(44, 187, 99, 0.15) 0 16px 32px";
                e.target.style.transform = "none";
              }}
            >
              Edit
            </button>
          </div>
        ), width: "100px"
      }   
    ];

  return (
    <div className="container-fluid page-body-wrapper">
      <div className="main-panel">
        <div className="content-wrapper">
          <ToastContainer
                                          position="top-center"
                                          autoClose={500}
                                          hideProgressBar={false}
                                          newestOnTop={false}
                                          closeOnClick
                                          rtl={false}
                                          pauseOnFocusLoss
                                          draggable
                                          pauseOnHover
                                          theme="colored"
                                        />
          <div className="container mainbody1" style={{ maxWidth: '1900px' }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h2 className="form-header">Store List</h2>
              <Link to="/addtstoredata" className="btn btn-success btn-sm one" style={{ marginRight: "-885px" }}>Add tStoreData</Link>
              <Link to="/addstores" className="btn btn-success btn-sm">Add Store</Link>
            </div>
            <div className="form-group my-3">
            <input
                type="text"
                placeholder="Search stores..."
                value={searchTerm}
                onChange={handleSearch}
                className="form-control"
            />
            </div>

            
            {/* Data Table */}
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
              striped
              responsive
              noDataComponent="No stores found."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListStores;
